export const SERVICE_URL = window.location.origin.includes("localhost") ? window.location.origin.replace("8080", "3000")
	: window.location.origin.replace('app.','service.');